import { Form, Spin, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { calculateColumnsWidth } from 'api/common';
import {
  ServiceMappingConfigPayload,
  ServiceMappingConfigPagedList,
  getServiceSourceMappings,
  MstRequest,
} from 'api/master';
import { LoadingScreen } from 'common/components';
import moment from 'moment';
import { useEffect, useState } from 'react';

// let servicemappingconfigPagedList: ServiceMappingConfigPagedList;
const servicemappingconfigPagedList: ServiceMappingConfigPagedList = { data: [], noOfRecords: 0, currentPageIndex: 1 };

type Props = {
  filter: MstRequest;
  onSubmit: (values: ServiceMappingConfigPayload) => Promise<void>;
};
const ServiceMaplist = ({ filter }: Props) => {
  const [_form] = Form.useForm<ServiceMappingConfigPayload>();
  const [pagedList, setPagedList] = useState(servicemappingconfigPagedList);
  //const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalLoading] = useState(false);
  // const [_isRetry, setRetry] = useState(false);

  //filter.userName = sessionStorage.getItem('user')?.toString();
  const [isFetching, setIsFetching] = useState(false);
  useEffect(() => {
    // 2. THE LOCK: If a parent re-render attempts a duplicate call, exit instantly!
    if (isFetching) return;
    setIsFetching(true);

    setIsLoading(false);
    // setPagedList(servicemappingconfigPagedList);
    const payload = { ...filter };
    payload.userName = sessionStorage.getItem('user')?.toString();
    payload.pageNo = 1;
    payload.pageSize = 10;
    // filter.pageNo = 1;
    // filter.pageSize = 10;
    debugger;
    getServiceSourceMappings(payload)
      .then((res) => {
        setPagedList(res.data);
      })
      .finally(() => {
        setIsLoading(true);

        // 3. RELEASE THE LOCK: Safe for subsequent new search filter clicks
        setIsFetching(false);
      });
    //  }, [filter]);
  }, [JSON.stringify(filter)]);

  const columns: ColumnsType<ServiceMappingConfigPayload> = [
    {
      key: 'sourceAppName',
      title: 'Source Application Name',
      dataIndex: 'sourceAppName',
      fixed: 'left',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
      className: '',
    },
    {
      key: 'serviceValue',
      title: 'Service Name',
      dataIndex: 'serviceValue',
      fixed: 'left',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },

    {
      key: 'createdOn',
      title: 'Created On',
      dataIndex: 'createdOn',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={moment(record).format('DD/MM/YYYY HH:mm:ss')}>
          {moment(record).format('DD/MM/YYYY HH:mm:ss')}
        </Tooltip>
      ),
    },
    {
      key: 'flag',
      title: 'Flag',
      dataIndex: 'flag',
      ellipsis: true,
      render: (flag) => (flag ? 'Active' : 'InActive'),
    },
    {
      key: 'moduleName',
      title: 'Module Name',
      dataIndex: 'moduleName',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'createdBy',
      title: 'Created By',
      dataIndex: 'createdBy',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
  ];

  // let payfilter: FilterPayload = {};
  if (!pagedList || !isLoading) {
    return <LoadingScreen />;
  }

  const handleChange = (_pagination: any, _filters: ServiceMappingConfigPayload, sorter: any) => {
    setIsLoading(false);

    if (sorter.hasOwnProperty('column')) {
      // params.order = { field: sorter.field, dir: sorter.order };
    }

    // filter.pageNo = _pagination.current;
    // filter.pageSize = _pagination.pageSize;

    // getServiceSourceMappings(filter).then((res) => {
    //   setPagedList(res.data);
    //   setIsLoading(true);
    // });

    // Setup an isolated clone copy for pagination parameters safely
    const payload = { ...filter };
    payload.userName = sessionStorage.getItem('user')?.toString();
    payload.pageNo = _pagination.current;
    payload.pageSize = _pagination.pageSize;

    getServiceSourceMappings(payload).then((res) => {
      setPagedList(res.data);
      setIsLoading(true);
    });
  };

  const maxWidthPerCell = 1000;

  const dataTable = calculateColumnsWidth(columns, pagedList.data, maxWidthPerCell);
  const tableHeight = 500;
  const rowKey = 'ROWNUM';

  return (
    <>
      <Spin spinning={isModalLoading}>
        <Table
          columns={dataTable.columns}
          dataSource={dataTable.source}
          rowKey={rowKey}
          scroll={{ x: dataTable.tableWidth, y: tableHeight }}
          pagination={{
            pageSize: 10,
            total: pagedList.noOfRecords,
            current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
          }}
          onChange={handleChange}
        />
      </Spin>
      ;
    </>
  );
};

export default ServiceMaplist;
